"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldConfigToJSON = exports.FieldConfigFromJSONTyped = exports.FieldConfigFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function FieldConfigFromJSON(json) {
    return FieldConfigFromJSONTyped(json, false);
}
exports.FieldConfigFromJSON = FieldConfigFromJSON;
function FieldConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldType': (0, _1.FieldTypeFromJSON)(json['fieldType']),
        'label': json['label'],
        'options': !(0, runtime_1.exists)(json, 'options') ? undefined : json['options'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'isRequired': !(0, runtime_1.exists)(json, 'isRequired') ? undefined : json['isRequired'],
        'saveRunningValues': !(0, runtime_1.exists)(json, 'saveRunningValues') ? undefined : json['saveRunningValues'],
        'runningValues': !(0, runtime_1.exists)(json, 'runningValues') ? undefined : json['runningValues'],
    };
}
exports.FieldConfigFromJSONTyped = FieldConfigFromJSONTyped;
function FieldConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fieldType': (0, _1.FieldTypeToJSON)(value.fieldType),
        'label': value.label,
        'options': value.options,
        'description': value.description,
        'isRequired': value.isRequired,
        'saveRunningValues': value.saveRunningValues,
        'runningValues': value.runningValues,
    };
}
exports.FieldConfigToJSON = FieldConfigToJSON;
